import React from "react";

export default function TaskModal({ editingTask, onSave, onClose }) {
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    onSave({
      title: formData.get("title"),
      date: formData.get("date"),
      status: formData.get("status"),
    });
  };

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center p-4 bg-slate-950/80 backdrop-blur-md">
      <div className="bg-white dark:bg-slate-900 rounded-[32px] w-full max-w-md p-8 shadow-2xl">
        <h2 className="text-2xl font-black mb-8 dark:text-white">
          {editingTask ? "Edit Task" : "New Task"}
        </h2>
        <form onSubmit={handleSubmit} className="space-y-6">
          <input
            name="title"
            defaultValue={editingTask?.title || ""}
            className="w-full p-4 bg-slate-50 dark:bg-slate-800 rounded-2xl dark:text-white outline-none"
            placeholder="Task Title"
            required
          />
          <div className="grid grid-cols-2 gap-4">
            <input
              name="date"
              type="datetime-local"
              defaultValue={editingTask?.date || ""}
              className="w-full p-4 bg-slate-50 dark:bg-slate-800 rounded-2xl dark:text-white text-sm"
              required
            />
            <select
              name="status"
              defaultValue={editingTask?.status || "Pending"}
              className="w-full p-4 bg-slate-50 dark:bg-slate-800 rounded-2xl dark:text-white"
            >
              <option value="Pending">Pending</option>
              <option value="Done">Done</option>
            </select>
          </div>
          <div className="flex gap-4">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 py-4 text-slate-400 font-bold"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-[2] bg-indigo-600 text-white py-4 rounded-2xl font-black"
            >
              {editingTask ? "Update" : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
